import {
  mediaQueryStyles,
  constants,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const { ui } = constants.colors;

export const containerCss = {
  maxWidth: 600,
  margin: 20,
  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    margin: 35,
    marginLeft: 50,
  },
  [breakpoint.downTo(constants.breakpoints.BreakpointNames.md)]: {
    margin: 35,
    marginLeft: 150,
  },
};

export const headerCss = {
  marginBottom: 30,
  h1: {
    ...typographyStyles.heading1Obj,
    fontFamily: typographyStyles.fontFamily.circular,
    color: constants.colors.ui.neutral[600],
    marginBottom: 5,
  },
  p: {
    ...typographyStyles.textSObj,
    margin: 0,
  },
};

export const formCss = {
  button: {
    marginTop: 10,
    minWidth: 150,
    justifyContent: "center",
  },
};

export const separatorCss = {
  border: "none",
  borderBottom: `1px solid ${ui.neutral[100]}`,
  margin: "25px 0",
};

export const noteCss = {
  p: {
    ...typographyStyles.textSObj,
    marginTop: 5,
  },
};
